export default __webpack_public_path__ + "static/media/fond-rectangle-blanc.150bc557.webp";